import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { get } from "utils/WebService";

export default function Juridico({ recordId }) {
    const [processos, setProcessos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (recordId) {
            get(`/contratos/list/${recordId}`)
                .then(res => {
                    if (res) {
                        const uniqueProcessos = [];
                        res.forEach(c => {
                            if (c.idProcesso && !uniqueProcessos.some(p => p.idProcesso === c.idProcesso)) {
                                uniqueProcessos.push({
                                    idProcesso: c.idProcesso,
                                    numeroProcesso: c.numeroProcesso,
                                    dataDistribuicao: c.dataDistribuicao,
                                    valorCausa: c.valorCausa,
                                    equipeResponsavel: c.equipeResponsavel,
                                    advogadoResponsavel: c.advogadoResponsavel,
                                    contratosLinked: res.filter(x => x.idProcesso === c.idProcesso).map(x => x.titulo).join(", ")
                                });
                            }
                        });
                        setProcessos(uniqueProcessos);
                    }
                })
                .catch(err => console.error(err))
                .finally(() => setLoading(false));
        }
    }, [recordId]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        try {
            if (typeof dateStr === "string" && dateStr.includes("-")) {
                const parts = dateStr.split("-");
                if (parts.length === 3) {
                    return `${parts[2].substring(0, 2)}/${parts[1]}/${parts[0]}`;
                }
            }
            return new Date(dateStr).toLocaleDateString("pt-BR");
        } catch (e) {
            return dateStr;
        }
    };

    const formatCurrency = (val) => {
        if (val === null || val === undefined) return "-";
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(val);
    };

    return (
        <MDBox mt={2}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDTypography variant="h6" fontWeight="medium">
                    Processos Ajuizados
                </MDTypography>
            </MDBox>

            <TableContainer component={Paper} sx={{ boxShadow: "none", border: "1px solid #e0e0e0" }}>
                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Número do Processo</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Data Distribuição</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Valor da Causa</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Equipe Responsável</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Advogado Responsável</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Contratos Vinculados</MDTypography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {processos.length === 0 && !loading && (
                            <TableRow>
                                <TableCell colSpan={6} align="center" sx={{ py: 3, borderBottom: "none" }}>
                                    <MDTypography variant="caption" color="text">Nenhum processo vinculado a este devedor.</MDTypography>
                                </TableCell>
                            </TableRow>
                        )}
                        {processos.map((proc, index) => (
                            <TableRow key={index} hover>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="medium" color="info">{proc.numeroProcesso}</MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{formatDate(proc.dataDistribuicao)}</MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{formatCurrency(proc.valorCausa)}</MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{proc.equipeResponsavel || "-"}</MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{proc.advogadoResponsavel || "-"}</MDTypography>
                                </TableCell>
                                <TableCell>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{proc.contratosLinked}</MDTypography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </MDBox>
    );
}
